// Single source of truth for the registered trademark mark.
export const TRADEMARK_SYMBOL = "®";
export const BRAND_NAME = "All Animal App";
export const BRAND_NAME_TM = `${BRAND_NAME}${TRADEMARK_SYMBOL}`;
